import React, { Component } from "react";

import AuthAdapterFactory from "./AuthAdapter";
import LinearProgress from "material-ui/Progress/LinearProgress";
import customPropTypes from "material-ui/utils/customPropTypes";
import { createStyleSheet } from "material-ui/styles";

const styleSheet = createStyleSheet("withAuthAdapter", (theme) => {
  window.theme = theme;
  return {
    spinner: {
      // position: "fixed",
      width: "100%",
    },
  };
});

export default (ComposedComponent) => {
  return class extends Component {
    static contextTypes = {
      styleManager: customPropTypes.muiRequired,
    };
    state = {};

    componentWillMount() {
      this.spinHandler = this._spinHandler.bind(this);

      AuthAdapterFactory.authAdapter.then((authAdapter) => {
        console.log("auth adapter created!", authAdapter);
        this.setState({ authAdapter });
        authAdapter.addSpinHandler(this.spinHandler);
      });
    }

    // since signing out destroys the authAdapter, and since we only "mount" a component once
    // we also need to addSpinHandler when new props are received (but the add method must then be idempotent)
    componentWillUpdate(props) {
      if (this.state.authAdapter) {
        this.state.authAdapter.addSpinHandler(this.spinHandler);
      }
    }
    componentWillUnmount() {
      if (this.state.authAdapter) {
        this.state.authAdapter.removeSpinHandler(this.spinHandler);
      }
    }
    _spinHandler(isSpinning) {
      this.setState({ isSpinning: isSpinning });
    }

    renderComposed() {
      if (this.state.authAdapter) {
        return (
          <ComposedComponent
            {...this.props}
            authAdapterFactory={{ authAdapter: this.state.authAdapter }}
          />
        );
      } else {
        return <div>loading auth adapter</div>;
      }
    }

    render() {
      const classes = this.context.styleManager.render(styleSheet);

      return (
        <div>
          {this.state.isSpinning ? (
            <div className={classes.spinner}>
              <LinearProgress mode="indeterminate" />
            </div>
          ) : null}
          {this.renderComposed()}
        </div>
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/lib/withAuthAdapter.js